<div class="d-flex popup-head align-items-center">
  <div class="popup-title mr-auto" translate>
    {{ templateType === 0 ? "lblSelectEmailTemplate" : "lblSelectSMSTemplate" }}
  </div>
  <div class="float-right">
    <a class="close mr-3" (click)="OnClose()" translate>
      <span class="" aria-hidden="true">&times;</span>
    </a>
  </div>
</div>

<div class="container">
  <div class="modal-content">
    <div class="modal-body">
      <div class="row">
        <div class="col-4">
          <input type="text" class="form-control mb-3" placeholder="{{ 'lblSearch' | translate }}"
            [(ngModel)]="searchTerm" />
        </div>
        <div class="col-6 totalcount">
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
            totalCount
            }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>
        <div class="table-responsive max-h357" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width:55px" scope="col">#</th>
                <th scope="col" sortable="Name" (sort)="onSort($event)" translate>
                  lblTemplateName
                </th>
                <th scope="col" sortable="Subject" (sort)="onSort($event)" translate>
                  lblSubject
                </th>
                <th scope="col" class="text-center" style="width: 100px" translate>
                  lblAction
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="template?.length>0; else load_else">
                <tr *ngFor="let item of template; let i=index">
                  <td>{{ i + 1}}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.subject }}</td>
                  <td class="text-center">
                    <div class="custom-control custom-checkbox m-auto">
                      <input type="radio" [value]="item.id" [(ngModel)]="selectedTemplateId"
                        class="custom-control-input" id="customCheck{{ item.id }}" />
                      <label class="custom-control-label" for="customCheck{{ item.id }}"></label>
                    </div>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="4" class="no-record" translate>lblNotemplatefound</td>
                </tr>
              </ng-template>

            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-lg" (click)="OnClose()" translate>lblCancel</button>
  </div>
</div>